// Main.js file.
// IIFE - Immediately Invoked Function Expression
(function (kullaflytt) {
    // The global jQuery object is passed as a parameter
    kullaflytt(window.jQuery, window, document);
}(function ($, window, document) {
    // The $ is now locally scoped
    // Listen for the jQuery ready event on the document
    $('.hamburger').click(function () {
       $(this).toggleClass('is-active');
       $('.widget_nav_menu').slideToggle();
    });

}));
